// @ts-nocheck

import {
  Vue, Options
} from 'vue-class-component'
import Header from '@/components/Header.vue'
import swal from 'sweetalert'
import * as bootstrap from 'bootstrap'
import { billTypeFactory } from '@/http/bill-type'
import { masterDataFactory } from '@/http/master-data'
import roleAccessManager from '@/utils/role-access-manager'

  @Options({
    components: {
      Header
    },
    data () {
      return {
        billType: [],
        billTypeActive: [],
        billTypeNonActive: [],
        totalBill: 0,
        data: {
          id: '',
          name: '',
          description: '',
          status: true,
          merchant_string_id: ''
        },
        // showModal: false,
        state: '',
        merchantStringIds: [],
        canCreate: false,
        canRead: false,
        canUpdate: false,
        canDelete: false
      }
    },
    methods: {
      save: function () {
        if (this.data.name == '') {
          swal('Nama tipe tagihan tidak boleh kosong', '', 'warning')
          return
        }
        if (this.state == 'add') {
          this.data.status = (this.data.status) ? 1 : 0,
          Promise.all([
            billTypeFactory.createBillType(this.data)
          ]).then(results => {
            if (results[0] != false) {
              swal('Sukses menyimpan tipe tagihan', '', 'success')
              // this.showModal = false
              this.myModal.hide()
              this.reload()
            } else {
              swal('Gagal menyimpan tipe tagihan', '', 'error')
            }
          }).catch((e) => {
            swal('Gagal menyimpan tipe tagihan', '', 'error')
            console.log(e)
          })
        } else {
          const data = {
            name: this.data.name,
            description: this.data.description,
            status: (this.data.status) ? 1 : 0,
            merchant_string_id: this.data.merchant_string_id
          }
          Promise.all([
            billTypeFactory.updateBillType(this.data.id, data)
          ]).then(results => {
            if (results[0] != false) {
              swal('Sukses menyimpan tipe tagihan', '', 'success')
              // this.showModal = false
              this.myModal.hide()
              this.reload()
            } else {
              swal('Gagal menyimpan tipe tagihan', '', 'error')
            }
          }).catch((e) => {
            swal('Gagal menyimpan tipe tagihan', '', 'error')
            console.log(e)
          })
        }
      },
      edit: function (index: any, type: any) {
        // open modal with selected data
        // this.showModal = true
        this.myModal.show()
        if (type == 'active') {
          var billType = this.billTypeActive[index]
        } else {
          var billType = this.billTypeNonActive[index]
        }
        const data = {
          id: billType.id,
          name: billType.name,
          description: billType.description,
          status: (billType.status == 1),
          merchant_string_id: billType.merchant_string_id || ''
        }
        this.data = data
        this.state = 'edit'
      },
      add: function () {
        // this.showModal = true
        this.myModal.show()
        this.data.id = ''
        this.data.name = ''
        this.data.description = ''
        this.data.status = true
        this.data.merchant_string_id = ''
        this.state = 'add'
      },
      reload: function () {
        Promise.all([
          billTypeFactory.billType()
        ]).then(results => {
          this.billType = results[0].data.bill_types
          this.billTypeActive = []
          this.billTypeNonActive = []
          this.billType.forEach((types: any) => {
            if (types.status == 1) {
              this.billTypeActive.push(types)
            } else {
              this.billTypeNonActive.push(types)
            }
          })
        })
      },
      generateStringID: function () {
        const name = this.data.name
        const string_id = name.replace(/ /g, '_')
        this.data.id = string_id.toLowerCase()
      }
    },
    async created () {
      return Promise.all([
        masterDataFactory.setting_data({ title: 'MERCHANT_STRING_IDS' })
      ]).then(results => {
        const merchantStringIds = results[0].data.setting
        if (merchantStringIds && merchantStringIds.value) {
          this.merchantStringIds = merchantStringIds.value.split(',')
        }
      })
        .catch((e) => {
          console.log(e)
        })
    },
    async mounted () {
      // Check read access to /bill/type
      if (!roleAccessManager.canRead('/bill/type')) {
        swal('Error', 'Anda tidak memiliki akses ke halaman ini', 'error')
          .then(() => {
            this.$router.push('/loginpage')
          })
        return
      }

      // Set permission flags
      this.canCreate = roleAccessManager.canCreate('/bill/type')
      this.canRead = roleAccessManager.canRead('/bill/type')
      this.canUpdate = roleAccessManager.canUpdate('/bill/type')
      this.canDelete = roleAccessManager.canDelete('/bill/type')

      const myModal = document.getElementById('formModal')
      if (myModal != null) {
        this.myModal = new bootstrap.Modal(myModal)
      }

      await Promise.all([
        billTypeFactory.billType()
      ]).then(results => {
        this.billType = results[0].data.bill_types
        this.billType.forEach((types: any) => {
          if (types.status == 1) {
            this.billTypeActive.push(types)
          } else {
            this.billTypeNonActive.push(types)
          }
        })
      })
    }
  })

export default class BillType extends Vue {}
